export const SHOW_SNACKBAR = 'SHOW_SNACKBAR'
export const SHOW_SNACKBAR_ERROR = 'SHOW_SNACKBAR_ERROR'
export const HIDE_SNACKBAR = 'HIDE_SNACKBAR'
export const SHOW_SNACKBAR_SUCCESS = 'SHOW_SNACKBAR_SUCCESS'
// Snackbar
export interface ShowSnackbar {
  type: typeof SHOW_SNACKBAR
  payload: {
    text: string
    icon: string | null
  }
}
export interface ShowSnackbarError {
  type: typeof SHOW_SNACKBAR_ERROR
  payload: {
    text: string
  }
}

export interface ShowSnackbarSuccess {
  type: typeof SHOW_SNACKBAR_SUCCESS
  payload: {
    text: string
  }
}

export interface HideSnackbar {
  type: typeof HIDE_SNACKBAR
  payload: null
}

export interface ShowSnackbarType {
  visible: boolean
  text: string
  icon: string | null
  type: string
  error: boolean
}

export const defaultShowSnackbar: ShowSnackbarType = {
  visible: false,
  text: '',
  icon: '',
  type: '',
  error: false,
}

export type SnackbarActions = ShowSnackbar | HideSnackbar | ShowSnackbarError | ShowSnackbarSuccess
